import React from "react";
import { Typography, Space, Card, Tag, Button, Badge, message } from "antd";
import "./style.css"
import { useMutation} from "react-query";
import {solutions} from '../../configurations/solution'
import { marketplace } from './api'
import { Link } from "react-router-dom";
const Marketplace = () => {
  const { Text, Title } = Typography;
   const mutation = useMutation((data)=>{
     return  marketplace.addSoutions(data)
   },{
     onSuccess:(data=>{
       if(data?.data?.success == true){
              message.success("Your Solution successfully installed",3)
              var user = JSON.parse(localStorage.getItem('loggedUser'))
              console.log(data?.data?.user?.solution)
              user['solution'] = data?.data?.user?.solution
              localStorage.setItem('loggedUser',JSON.stringify(user))

       }
       else{
         message.error("Something Went Wrong",3)
       }
       console.log(data)
     })
   })
  return (
    <Space style={{ background: "#f0f0f0" }}>
      <Space direction="vertical">
        <Space direction="vertical" className="marketplace">
          <Text>
            <h3>Sehahub Apps Marketplace</h3>
          </Text>
          <Text>
            <strong>Use your favourite apps in Sehahub</strong>
          </Text>
        </Space>

        <Space direction="vertical" className="popular_apps">

          <Text>
            <Title level={5}>Popular Apps</Title>
          </Text>

          <Space className="cards_res">
            {
              solutions?.map(item=>{
                var user = JSON.parse(localStorage.getItem('loggedUser'))
                let currentSolution = user?.solution?.find(solution=>solution?.id == item?.id)
                console.log(user)
                console.log(currentSolution)
                return  <Badge.Ribbon text="Free">
                <Card style={{ width: 320 }}>
                  <Title level={5}>{item?.title}</Title>
                  <Text type="secondary">
                   {item?.description}
                  </Text>
                  <Space direction="vertical" className="install_button">
                    <Space>
                      {
                        currentSolution== undefined ?
                      <button className="btn" onClick={()=>{
                        if(user != null){
                        mutation.mutateAsync({
                             token:user?.jwtToken,
                             type:user?.type,
                             solution:[{
                               key:item?.title,
                               id:item?.id
                             }]

                        })
                      }
                      else{
                        message.warning("Please login first",3)
                      }
                      }}>{item?.btn_text}</button>:null}
                    </Space>
                  </Space>
                </Card>
              </Badge.Ribbon>
              })
            }
          </Space>
        </Space>
      </Space>
    </Space>
  );
};

export default Marketplace